<template>
    <div v-if="hasTrip" class="incident-live-tracking-cell">
        <!-- <div class="incident-live-tracking-cell__copy">
            <strong class="incident-live-tracking-cell__lot">{{ rowData.trip_lot_number || '---' }}</strong>
            <span v-if="rowData.trip_horse" class="incident-live-tracking-cell__horse">{{ rowData.trip_horse }}</span>
        </div> -->

        <button
            type="button"
            class="btn incident-live-tracking-cell__button"
            :class="trackingButtonClass"
            :disabled="isLoading"
            @click.prevent="openLiveTracking"
        >
            <span v-if="isLoading" class="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
            <span v-else class="incident-live-tracking-cell__status-dot" :class="{ 'incident-live-tracking-cell__status-dot--assigned': hasAssignedTracker }"></span>
            <strong class="incident-live-tracking-cell__lot">{{ rowData.trip_lot_number || '---' }}</strong> 
            <!-- <span v-if="rowData.trip_horse" class="incident-live-tracking-cell__horse">{{ rowData.trip_horse }}</span> -->
            - {{ $t('live_tracking') }}
        </button>

        <trip-current-position-modal
            v-if="isPositionModalActive && tripContext"
            :key="positionModalKey"
            :trip-data="tripContext"
            @close-modal="closePositionModal"
        />
    </div>
    <span v-else class="text-muted">---</span>
</template>

<script>
import CoreLibrary from '../../../../core/helpers/CoreLibrary';
import { INCIDENT_TRIP_LIVE_CONTEXT } from '../../../Config/ApiUrl';

export default {
    name: 'IncidentTripLiveTrackingCell',
    extends: CoreLibrary,
    props: {
        value: {
            default: null,
        },
        rowData: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            isLoading: false,
            isPositionModalActive: false,
            positionModalKey: 0,
            tripContext: null,
        };
    },
    computed: {
        hasTrip() {
            return Boolean(this.value || this.rowData.trip_id);
        },
        tripId() {
            return this.value || this.rowData.trip_id || null;
        },
        hasAssignedTracker() {
            return Boolean(
                this.rowData.effective_device_name
                || this.rowData.effective_device_imei
                || this.rowData.active_device_name
                || this.rowData.active_device_imei
            );
        },
        trackingButtonClass() {
            return this.hasAssignedTracker
                ? 'incident-live-tracking-cell__button--assigned'
                : 'incident-live-tracking-cell__button--unassigned';
        },
    },
    methods: {
        openLiveTracking() {
            if (!this.tripId) {
                return;
            }

            this.isLoading = true;

            this.axiosGet(`${INCIDENT_TRIP_LIVE_CONTEXT}/${this.tripId}`)
                .then(({ data }) => {
                    this.tripContext = data;
                    this.positionModalKey += 1;

                    if (this.isPositionModalActive) {
                        this.isPositionModalActive = false;
                        this.$nextTick(() => {
                            this.isPositionModalActive = true;
                        });
                        return;
                    }

                    this.isPositionModalActive = true;
                })
                .catch(({ response }) => {
                    this.$toastr.e(response?.data?.message || this.$t('failed_response'));
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        closePositionModal() {
            this.isPositionModalActive = false;
        },
    },
};
</script>

<style scoped>
.incident-live-tracking-cell {
    display: inline-flex;
    align-items: center;
    gap: 0.75rem;
    flex-wrap: wrap;
}

.incident-live-tracking-cell__copy {
    display: inline-flex;
    flex-direction: column;
    line-height: 1.3;
}

.incident-live-tracking-cell__lot {
    font-weight: 700;
}

.incident-live-tracking-cell__horse {
    font-size: 0.78rem;
    color: var(--muted-font-color);
}

.incident-live-tracking-cell__button {
    display: inline-flex;
    align-items: center;
    border-radius: 999px;
    padding: 0.28rem 0.7rem;
    font-size: 0.8rem;
    line-height: 1.2;
    white-space: nowrap;
}

.incident-live-tracking-cell__button--assigned {
    border-color: rgba(22, 163, 74, 0.28);
    background: rgba(22, 163, 74, 0.08);
    color: #166534;
}

.incident-live-tracking-cell__button--unassigned {
    border-color: rgba(220, 38, 38, 0.24);
    background: rgba(220, 38, 38, 0.08);
    color: #b91c1c;
}

.incident-live-tracking-cell__status-dot {
    width: 0.55rem;
    height: 0.55rem;
    margin-right: 0.45rem;
    border-radius: 999px;
    background: #dc2626;
    box-shadow: 0 0 0 4px rgba(220, 38, 38, 0.12);
    flex: 0 0 auto;
}

.incident-live-tracking-cell__status-dot--assigned {
    background: #16a34a;
    box-shadow: 0 0 0 4px rgba(22, 163, 74, 0.12);
}
</style>
